module.exports = __webpack_public_path__ + "media/1x1/kz-a19240f6.svg";